module.exports = __webpack_public_path__ + "static/img/alert_success_bg.4287795c.png";